import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";
import "./TeamSection.css";

const team = [
 {
    img: "", // blank (no profile picture)
    name: "Dr. Mohan S Gundeti",
    role: "Founder and Chief Surgeon, MD, MCh, FEBU, FRCS (Urol) FEAPU",
  },
  {
    img: "",
    name: "Dr. Madhav S Gundeti",
    role: "President and CEO",
  },
  {
    img: "",
    name: "Aaryan M Gundeti",
    role: "Leadership Team",
  },
  {
    img: "",
    name: "Mrs. Lalita M Gundeti",
    role: "Patient Liaison and Relationship",
  },
  {
    img: "",
    name: "Mr. Shriniwas Sabban",
    role: "Administrator, MBA",
  },
  {
    img: "",
    name: "Sriniwas Samleti",
    role: "Administrator, MBA",
  },
  {
    img: "",
    name: "Ganesh Shriram",
    role: "Administrator",
  },
  {
    img: "",
    name: "Rajesh",
    role: "Administrator, MBA",
  },
];

const TeamSection = () => (
  <Box
    className="team-container"
    component={motion.div}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
    sx={{
      background: "none",
      py: { xs: 3, sm: 5, md: 12 },
      fontFamily: "Poppins, Arial, sans-serif",
    }}
  >
    <Container>
      <Box
        className="team-inner-container"
        sx={{
          background: "#f7fbff",
          borderRadius: "2.5rem",
          maxWidth: 1100,
          mx: "auto",
          mb: 4,
          mt: 0,
          pt: 0,
          p: { xs: 2, sm: 3, md: 6 },
          boxShadow: "0 2px 16px 0 rgba(0,0,0,0.04)",
        }}
      >
        <Box
          className="team-header"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: { xs: 2, sm: 3, md: 5 },
            gap: 2,
          }}
        >
          <Typography
            className="team-title"
            variant="h3"
            sx={{
              fontWeight: 900,
              color: "var(--color-black)",
              letterSpacing: 1,
              textAlign: "center",
              fontSize: { xs: "1.25rem", sm: "1.75rem", md: "2.5rem" },
              mx: "auto",
              px: { xs: 2, md: 0 }
            }}
          >
            Our Team
          </Typography>
        </Box>
        <Grid className="team-grid" container spacing={{ xs: 2, sm: 3, md: 4 }} justifyContent="center">
          {team.map((member, idx) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={idx}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                className="team-card"
                sx={{
                  width: { xs: '100%', sm: 240, md: 240 },
                  maxWidth: { xs: 280, sm: 240, md: 240 },
                  height: { xs: 260, sm: 300, md: 340 },
                  background: "#fafbfc",
                  borderRadius: 2,
                  boxShadow: "0 4px 24px 0 rgba(0,0,0,0.07)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  overflow: "hidden",
                  p: 0,
                  m: 0,
                  transition: "box-shadow 0.3s",
                  "&:hover .team-card-content": {
                    background: "var(--color-accent-green)",
                  },
                  "&:hover .team-card-content .team-card-name, &:hover .team-card-content .team-card-role":
                    {
                      color: "#fff",
                    },
                }}
              >
                <Box
                  className="team-card-image-container"
                  sx={{
                    width: "100%",
                    aspectRatio: "1/1",
                    overflow: "hidden",
                    background: "#f3f3f3",
                    borderRadius: 0,
                  }}
                >
                  <img
                    className="team-card-image"
                    src={member.img}
                    alt={member.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                      borderRadius: 0,
                    }}
                  />
                </Box>
                <Box
                  className="team-card-content"
                  sx={{
                    width: "100%",
                    textAlign: "center",
                    p: { xs: 1.5, sm: 2 },
                    background: "#fafbfc",
                    minHeight: { xs: 80, sm: 100, md: 110 },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    borderBottomLeftRadius: 12,
                    borderBottomRightRadius: 12,
                    transition: "background 0.3s, color 0.3s",
                  }}
                >
                  <Typography
                    className="team-card-name"
                    variant="h6"
                    sx={{
                      fontWeight: 800,
                      color: "#111",
                      mb: 0.5,
                      fontSize: { xs: '0.9rem', sm: '1rem', md: '1.18rem' },
                      fontFamily: "Poppins, Arial, sans-serif",
                      transition: "color 0.3s",
                      lineHeight: 1.2,
                    }}
                  >
                    {member.name}
                  </Typography>
                  <Typography
                    className="team-card-role"
                    variant="body2"
                    sx={{
                      color: "#888",
                      fontWeight: 500,
                      fontSize: { xs: '0.75rem', sm: '0.85rem', md: '1.02rem' },
                      fontFamily: "Poppins, Arial, sans-serif",
                      transition: "color 0.3s",
                      lineHeight: 1.3,
                    }}
                  >
                    {member.role}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  </Box>
);

export default TeamSection;
